import newLogoImg from "../assets/images/new-logo.svg";
import carexLogo from "../assets/images/Careexpand-Logo-no-padding.png";
import dapperLogoBlue from "../assets/images/dapperLogo_Blue.png";

type HostConfig = {
    logo: string;
    mobileLogo?: string;
    isCareExpand: boolean;
    width: string;
};

declare global {
    interface Document {
        setDapperCareLogoCookie: () => void;
    }
}

const hostConfig: Record<string, HostConfig> = {
    "app-dev.careexpand.com": {
        logo: newLogoImg,
        mobileLogo: carexLogo,
        width: "200px",
        isCareExpand: true,
    },
    "app.careexpand.com": {
        logo: newLogoImg,
        mobileLogo: carexLogo,
        width: "200px",
        isCareExpand: true,
    },
    "app.dappercare.careexpand.com": {
        logo: dapperLogoBlue,
        mobileLogo: dapperLogoBlue,
        width: "160px",
        isCareExpand: false,
    },
};

document.setDapperCareLogoCookie = () => {
    document.cookie = "isDapperCareLogo=1";
};

let selectedHostConfig: HostConfig;
if (window.location.hostname === "app-dev.careexpand.com" && document.cookie.includes("isDapperCareLogo=1")) {
    // For demo purpose
    selectedHostConfig = hostConfig["app.dappercare.careexpand.com"];
} else {
    selectedHostConfig = hostConfig[window.location.hostname] || hostConfig["app.careexpand.com"];
}

export default selectedHostConfig;
